{
  "a1": {
    "radius": 0.515,
    "elevation": 0.002
  },
  "ability_hand": {
    "radius": 0.089,
    "elevation": 0.089
  },
  "aliengo": {
    "radius": 0.472,
    "elevation": -0.184
  },
  "allegro_hand": {
    "radius": 0.126,
    "elevation": 0.116
  },
  "anymal_b": {
    "radius": 0.92,
    "elevation": 0.003
  },
  "anymal_c": {
    "radius": 0.961,
    "elevation": 0.007
  },
  "anymal_d": {
    "radius": 1.045,
    "elevation": -0.002
  },
  "atlas_drc": {
    "radius": 1.246,
    "elevation": 0.264
  },
  "atlas_v4": {
    "radius": 0.989,
    "elevation": 0.127
  },
  "b1": {
    "radius": 0.939,
    "elevation": 0.016
  },
  "b2": {
    "radius": 0.927,
    "elevation": -0.009
  },
  "bambot": {
    "radius": 0.458,
    "elevation": 0.363
  },
  "barrett_hand": {
    "radius": 0.175,
    "elevation": 0.097
  },
  "baxter": {
    "radius": 1.16,
    "elevation": 0.441
  },
  "berkeley_humanoid": {
    "radius": 0.447,
    "elevation": -0.276
  },
  "bolt": {
    "radius": 0.402,
    "elevation": -0.036
  },
  "booster_t1": {
    "radius": 0.632,
    "elevation": -0.012
  },
  "cassie": {
    "radius": 0.808,
    "elevation": -0.159
  },
  "draco3": {
    "radius": 0.832,
    "elevation": -0.078
  },
  "edo": {
    "radius": 0.481,
    "elevation": 0.481
  },
  "ergocub": {
    "radius": 0.87,
    "elevation": 0.09
  },
  "eve_r3": {
    "radius": 1.031,
    "elevation": 0.141
  },
  "finger_edu": {
    "radius": 0.318,
    "elevation": 0.192
  },
  "g1": {
    "radius": 0.739,
    "elevation": -0.046
  },
  "gen2": {
    "radius": 0.752,
    "elevation": 0.39
  },
  "gen3_lite": {
    "radius": 0.716,
    "elevation": 0.287
  },
  "go1": {
    "radius": 0.521,
    "elevation": 0.016
  },
  "go2": {
    "radius": 0.561,
    "elevation": -0.015
  },
  "gr1": {
    "radius": 0.896,
    "elevation": 0.028
  },
  "h1": {
    "radius": 0.872,
    "elevation": -0.102
  },
  "h1_2": {
    "radius": 1.058,
    "elevation": 0.074
  },
  "hyq": {
    "radius": 0.963,
    "elevation": -0.328
  },
  "icub": {
    "radius": 0.591,
    "elevation": -0.049
  },
  "iiwa14": {
    "radius": 0.829,
    "elevation": 0.553
  },
  "jaxon": {
    "radius": 1.024,
    "elevation": 0.102
  },
  "jvrc": {
    "radius": 0.907,
    "elevation": 0.14
  },
  "leap_hand_v1": {
    "radius": 0.105,
    "elevation": -0.049
  },
  "minitaur": {
    "radius": 0.21,
    "elevation": 0.056
  },
  "n1": {
    "radius": 0.669,
    "elevation": 0.008
  },
  "nextage": {
    "radius": 0.555,
    "elevation": 0.345
  },
  "open_manipulator_x": {
    "radius": 0.339,
    "elevation": 0.137
  },
  "panda": {
    "radius": 0.818,
    "elevation": 0.42
  },
  "pepper": {
    "radius": 0.767,
    "elevation": 0.648
  },
  "piper": {
    "radius": 0.677,
    "elevation": 0.241
  },
  "poppy_ergo_jr": {
    "radius": 0.089,
    "elevation": 0.078
  },
  "poppy_torso": {
    "radius": 0.253,
    "elevation": 0.192
  },
  "pr2": {
    "radius": 1.102,
    "elevation": 0.782
  },
  "r2": {
    "radius": 1.322,
    "elevation": -0.065
  },
  "reachy": {
    "radius": 0.822,
    "elevation": 0.776
  },
  "robotiq_2f85": {
    "radius": 0.085,
    "elevation": 0.085
  },
  "romeo": {
    "radius": 0.823,
    "elevation": -0.252
  },
  "so_arm100": {
    "radius": 0.304,
    "elevation": 0.157
  },
  "solo": {
    "radius": 0.505,
    "elevation": -0.006
  },
  "stretch": {
    "radius": 0.752,
    "elevation": 0.657
  },
  "talos": {
    "radius": 1.029,
    "elevation": -0.054
  },
  "tiago": {
    "radius": 0.948,
    "elevation": 0.825
  },
  "trifinger_edu": {
    "radius": 0.33,
    "elevation": 0.224
  },
  "upkie": {
    "radius": 0.369,
    "elevation": -0.263
  },
  "ur10": {
    "radius": 1.244,
    "elevation": 0.153
  },
  "ur3": {
    "radius": 0.48,
    "elevation": 0.119
  },
  "ur5": {
    "radius": 0.803,
    "elevation": 0.166
  },
  "valkyrie": {
    "radius": 1.064,
    "elevation": -0.098
  },
  "yumi": {
    "radius": 0.738,
    "elevation": 0.603
  },
  "z1": {
    "radius": 0.562,
    "elevation": 0.357
  },
  "abb_irb120": {
    "radius": 0.606,
    "elevation": 0.368
  },
  "abb_irb1200": {
    "radius": 0.849,
    "elevation": 0.48
  },
  "abb_irb1600": {
    "radius": 1.153,
    "elevation": 0.673
  },
  "abb_irb2400": {
    "radius": 1.412,
    "elevation": 0.76
  },
  "abb_irb2600": {
    "radius": 1.438,
    "elevation": 0.598
  },
  "abb_irb4400": {
    "radius": 2.154,
    "elevation": 1.1
  },
  "abb_irb4600": {
    "radius": 1.938,
    "elevation": 0.666
  },
  "abb_irb5400": {
    "radius": 2.659,
    "elevation": 1.347
  },
  "abb_irb6640": {
    "radius": 2.487,
    "elevation": 1.345
  },
  "abb_irb7600": {
    "radius": 3.134,
    "elevation": 1.407
  },
  "kuka_kr5_arc": {
    "radius": 1.362,
    "elevation": 0.411
  },
  "kuka_kr10r1100sixx": {
    "radius": 1.064,
    "elevation": 0.501
  },
  "kuka_kr16_2": {
    "radius": 1.587,
    "elevation": 0.956
  },
  "kuka_kr120r2500pro": {
    "radius": 2.494,
    "elevation": 1.169
  },
  "fanuc_crx3ia": {
    "radius": 0.646,
    "elevation": 0.172
  },
  "fanuc_crx5ia": {
    "radius": 0.911,
    "elevation": 0.166
  },
  "fanuc_crx10ia": {
    "radius": 1.099,
    "elevation": 0.137
  },
  "fanuc_crx10ia_l": {
    "radius": 1.314,
    "elevation": 0.334
  },
  "fanuc_crx10ia_lp": {
    "radius": 1.33,
    "elevation": 0.429
  },
  "fanuc_crx20ia_l": {
    "radius": 1.215,
    "elevation": 0.19
  },
  "fanuc_crx30ia": {
    "radius": 1.819,
    "elevation": 0.344
  },
  "fanuc_er4ia": {
    "radius": 0.568,
    "elevation": 0.404
  },
  "fanuc_lrmate200id": {
    "radius": 0.69,
    "elevation": 0.426
  },
  "fanuc_lrmate200id_4s": {
    "radius": 0.542,
    "elevation": 0.396
  },
  "fanuc_lrmate200id_7c": {
    "radius": 0.638,
    "elevation": 0.434
  },
  "fanuc_lrmate200id_7l": {
    "radius": 0.908,
    "elevation": 0.422
  },
  "fanuc_lrmate200id_7lc": {
    "radius": 0.9,
    "elevation": 0.372
  },
  "fanuc_lrmate200id_7we": {
    "radius": 0.66,
    "elevation": 0.442
  },
  "fanuc_lrmate10_11a": {
    "radius": 1.004,
    "elevation": 0.526
  },
  "fanuc_lrmate10_11afc": {
    "radius": 1.072,
    "elevation": 0.483
  },
  "fanuc_lrmate25_19a": {
    "radius": 1.772,
    "elevation": 0.732
  },
  "fanuc_lrmate25_19afc": {
    "radius": 1.683,
    "elevation": 0.916
  },
  "fanuc_lrmate35_14a": {
    "radius": 1.353,
    "elevation": 0.759
  },
  "fanuc_m10_8_20d": {
    "radius": 1.967,
    "elevation": 0.648
  },
  "fanuc_m10_10_16d": {
    "radius": 1.625,
    "elevation": 0.517
  },
  "fanuc_m10_12_14d": {
    "radius": 1.263,
    "elevation": 0.59
  },
  "fanuc_m10_16_11d": {
    "radius": 1.005,
    "elevation": 0.578
  },
  "fanuc_m20_12_23d": {
    "radius": 2.142,
    "elevation": 0.497
  },
  "fanuc_m20_25_18d": {
    "radius": 1.602,
    "elevation": 0.507
  },
  "fanuc_m20_35_18d": {
    "radius": 1.733,
    "elevation": 0.484
  },
  "fanuc_m710ic_12l": {
    "radius": 3.047,
    "elevation": 0.847
  },
  "fanuc_m710ic_20l": {
    "radius": 3.06,
    "elevation": 0.965
  },
  "fanuc_m710ic_20m": {
    "radius": 2.456,
    "elevation": 0.821
  },
  "fanuc_m710ic_45m": {
    "radius": 2.274,
    "elevation": 0.733
  },
  "fanuc_m710ic_50": {
    "radius": 1.853,
    "elevation": 0.857
  },
  "fanuc_m710ic_50e": {
    "radius": 1.833,
    "elevation": 0.784
  },
  "fanuc_m710ic_50s": {
    "radius": 1.144,
    "elevation": 0.781
  },
  "fanuc_m710ic_70": {
    "radius": 2.045,
    "elevation": 0.873
  },
  "fanuc_m710id_50m": {
    "radius": 2.232,
    "elevation": 0.749
  },
  "fanuc_m710id_70": {
    "radius": 2.013,
    "elevation": 0.855
  },
  "fanuc_m800_60_20b": {
    "radius": 1.961,
    "elevation": 0.761
  },
  "fanuc_p350ia_45_lh": {
    "radius": 2.323,
    "elevation": 0.778
  },
  "fanuc_p350ia_45_rh": {
    "radius": 2.643,
    "elevation": 0.902
  },
  "fanuc_r1000ia_80f": {
    "radius": 2.181,
    "elevation": 0.546
  },
  "fanuc_r1000ia_100f": {
    "radius": 1.897,
    "elevation": 0.551
  },
  "fanuc_r1000ia_130f": {
    "radius": 2.031,
    "elevation": 0.501
  },
  "fanuc_r2000ic_100p": {
    "radius": 3.226,
    "elevation": 0.737
  },
  "fanuc_r2000ic_100ph": {
    "radius": 3.417,
    "elevation": 0.764
  },
  "fanuc_r2000ic_125l": {
    "radius": 2.564,
    "elevation": 1.434
  },
  "fanuc_r2000ic_165f": {
    "radius": 2.363,
    "elevation": 1.353
  },
  "fanuc_r2000ic_165r": {
    "radius": 3.085,
    "elevation": 0.661
  },
  "fanuc_r2000ic_190s": {
    "radius": 2.024,
    "elevation": 0.895
  },
  "fanuc_r2000ic_190u": {
    "radius": 2.783,
    "elevation": 1.454
  },
  "fanuc_r2000ic_210f": {
    "radius": 2.207,
    "elevation": 1.529
  },
  "fanuc_r2000ic_210l": {
    "radius": 2.743,
    "elevation": 1.616
  },
  "fanuc_r2000ic_210r": {
    "radius": 2.756,
    "elevation": 0.591
  },
  "fanuc_r2000ic_210we": {
    "radius": 2.706,
    "elevation": 1.446
  },
  "fanuc_r2000ic_220u": {
    "radius": 2.494,
    "elevation": 1.387
  },
  "fanuc_r2000ic_240f": {
    "radius": 1.856,
    "elevation": 1.344
  },
  "fanuc_r2000ic_270f": {
    "radius": 2.36,
    "elevation": 1.424
  },
  "fanuc_r2000ic_270r": {
    "radius": 2.864,
    "elevation": 0.662
  },
  "fanuc_r2000id_100fh": {
    "radius": 2.474,
    "elevation": 1.481
  },
  "fanuc_r2000id_165fh": {
    "radius": 2.208,
    "elevation": 1.426
  },
  "fanuc_r2000id_210fh": {
    "radius": 2.344,
    "elevation": 1.383
  },
  "fetch": {
    "radius": 0.986,
    "elevation": 0.922
  },
  "iiwa7": {
    "radius": 0.773,
    "elevation": 0.493
  },
  "mini_cheetah": {
    "radius": 0.399,
    "elevation": 0.002
  },
  "sigmaban": {
    "radius": 0.361,
    "elevation": -0.08
  },
  "skydio_x2": {
    "radius": 0.3,
    "elevation": 0.05
  },
  "wuji_hand": {
    "radius": 0.106,
    "elevation": 0.097
  }
}
